import {Affix, Anchor, Button, Flex, Form} from 'antd'
import {FormInstance} from 'antd/lib/form'
import React, {ReactElement} from 'react'

interface AnchorsFormProps {
    children?: React.ReactNode
    form: FormInstance
    onFinish: () => void
    onCancel?: () => void
    showAnchors?: boolean
}

export const AnchorsForm = ({children, form, onFinish, onCancel, showAnchors}: AnchorsFormProps) => {
    function generateAnchors() {
        return showAnchors && React.Children.toArray(children)
            .map(child => {
                if (React.isValidElement(child)) {
                    const node = child as ReactElement
                    if (node.props && node.props['title'] && node.props['id']) {
                        return {id: node.props['id'], title: node.props['title']}
                    }
                }
                return undefined
            })
            .filter(data => data !== undefined)
            .map((data) => (
                {
                    key: data.id,
                    href: '#' + data.id,
                    title: data.title
                }
            ))
    }

    const anchors = generateAnchors()

    return (
        <Flex>
            <Form
                style={{minWidth: 600, flex: 1}}
                onFinish={onFinish}
                form={form}
                layout="horizontal"
                autoComplete="off"
                colon={false}
                labelAlign="right"
                labelCol={{span: 4}}
                wrapperCol={{span: 16}}
            >
                {children}
            </Form>
            {anchors && anchors.length > 1 &&
                <Affix offsetTop={84}>
                    <Flex vertical align={'center'}>
                        <Anchor
                            offsetTop={84}
                            style={{
                                padding: '16px',
                                paddingLeft: 0,
                                backgroundColor: '#FFFFFF',
                                width: '200px',
                                marginLeft: '16px'
                            }}
                            items={anchors}
                        />
                        {onCancel &&
                            <div style={{marginTop: 8, textAlign: "center"}}>
                                <Button type="primary" className="adsp-button" htmlType="button" danger ghost
                                        onClick={onCancel}>
                                    Cancel
                                </Button>
                            </div>
                        }
                    </Flex>
                </Affix>
            }
        </Flex>
    )
}